"use client";

import { useBranch } from "@/context/branch-context";
import { useLocalization } from "@/context/localization-context";
import { BranchComparisonBase } from "./branch-comparison-base";

interface AllBranchesComparisonProps {
  className?: string;
}

export function AllBranchesComparison({
  className,
}: AllBranchesComparisonProps) {
  const { selectedBranchIds } = useBranch();
  const { t, formatNumber } = useLocalization();
  const selectedCount = selectedBranchIds.length;
  const hasSelection = selectedCount > 0;

  const title =
    selectedCount === 0
      ? t("comparison.titleAll")
      : selectedCount === 1
        ? t("comparison.titleOne")
        : t("comparison.titleSelected");

  const description =
    selectedCount === 0
      ? t("comparison.descriptionAll")
      : selectedCount === 1
        ? t("comparison.descriptionOne")
        : t("comparison.descriptionSelected", {
            count: formatNumber(selectedCount),
          });

  return (
    <BranchComparisonBase
      className={className}
      title={title}
      description={description}
      selectedBranches={hasSelection ? selectedBranchIds : undefined}
      showAverage={selectedCount !== 1}
      maxBranches={hasSelection ? selectedCount : 15}
    />
  );
}
